export default __webpack_public_path__ + "static/media/clock-outline.1917f3e1.svg";